import { useCallback, useEffect, useState } from "react";
import ModalComponent from "../modal";
import { IFlashMessage } from "../../@data";
import { Typography } from "@mui/material";
import Button from "../button";
import { onValue, ref } from "firebase/database";
import { useAuth } from "../../contexts";
import { database } from "../../services/firebase";
import * as s from "./styles";
const FlashMessage = () => {
  const { user } = useAuth();
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState<IFlashMessage | null>(null);

  const handleCloseModal = useCallback(() => setOpen(false), []);

  useEffect(() => {
    const userRef = ref(database, `users/${user.uid}`);

    onValue(userRef, (snapshot) => {
      const values = snapshot.val();
      if (values?.title) {
        setMessage(values);
        setOpen(true);
      }
    });
  }, [user.uid]);

  return (
    <ModalComponent
      title="Training modal component"
      open={open && message?.title && message?.imageUrl ? true : false}
      handleClose={() => handleCloseModal()}
    >
      <s.FlashImage src={message?.imageUrl} />
      <Typography variant="body1" sx={{ mt: 2, mb: 2 }}>
        {message?.title}
      </Typography>
      <Typography variant="body2" sx={{ mb: 2 }}>
        {message?.message}
      </Typography>
      <Button
        fullWidth
        variant="contained"
        size="large"
        onClick={() => window.open(message?.link, "_blank")}
      >
        Quero aproveitar
      </Button>
      <Button
        sx={{ mt: 1 }}
        fullWidth
        variant="text"
        size="large"
        onClick={handleCloseModal}
      >
        Vou deixar passar
      </Button>
    </ModalComponent>
  );
};

export default FlashMessage;
